"use client";
import { useState } from "react";
import SignupSlider from "../../Components/Signupslider/index";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { handleApiCall } from "../../apis";
import { endpoint } from "../../utils/endpoints";
const Finishsignup = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const location = useLocation();
  const navigate = useNavigate();
  const initialData = location.state || {};
  console.log(initialData, "initialData finish signup");
  const validatePassword = (password) => {
    const minLength = password.length >= 8;
    const specialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);
    return minLength && specialChar;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!password || !confirmPassword) {
      toast.error("Password fields cannot be empty");
      return;
    }

    if (!validatePassword(password)) {
      toast.error(
        "Password must be at least 8 characters and contain a special character"
      );
      return;
    }

    if (password !== confirmPassword) {
      toast.error("Passwords do not match");
      return;
    }

    // Get email from previous steps/state
    const signupData = initialData.Signupdata || {};
    const email = signupData.email || "";

    if (!email) {
      toast.error("Email is missing. Please go back and complete the form.");
      return;
    }

    setLoading(true);

    try {
      // Build simple step 3 payload
      const apiBody = {
        step: "3",
        email,
        password,
        confirmPassword,
      };
      console.log(apiBody, "apiBody");

      const response = await handleApiCall(
        "post",
        `${endpoint.registerVendor}`,
        apiBody
      );
      console.log(response, "response");
      if (response?.data?.code === 200 || response?.status === 200) {
        toast.success("Signup successful! Please verify your email.");
        // Navigate to OTP verification screen
        navigate("/otpverification", {
          state: {
            email: email,
            type: "vendorSignUp",
          },
        });
      } else {
        toast.error(
          response?.response?.data?.errorMessage ||
            response?.data?.message ||
            "Signup failed"
        );
      }
    } catch (error) {
      console.error("Signup error:", error);
      toast.error(
        error?.response?.data?.errorMessage || "An error occurred during signup"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="w-full md:flex block">
        <div className="md:w-6/12 w-full">
          <div className="flex justify-center h-screen">
            <div className="block md:w-80 w-10/12 space-y-2 mt-[30px]">
              <img src="/images/black-logo.svg" alt="" className="mx-auto" />
              <div>
                <h1 className="text-2xl text-black text-center font-BonaNovaRegular py-2">
                  Sign up as vendor
                </h1>
                <img
                  src="/images/progress-two.png"
                  alt=""
                  className="w-40 mx-auto py-2"
                />
                <form onSubmit={handleSubmit} className="mt-4">
                  <div className="text-[13px] font-Montserratmedium text-[#2B2B2B] opacity-50 mb-[5px]">
                    Password
                  </div>
                  <div className="mb-2 relative">
                    <input
                      type={showPassword ? "text" : "password"}
                      name="password"
                      placeholder="Password"
                      required
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      className="mt-1 w-full px-3 py-2 border !border-inputfieldborder pr-10 bg-white outline-none text-13 font-Montserratmedium text-forgetpassword min-h-[42px]"
                    />
                    <button
                      type="button"
                      onClick={() => setShowPassword(!showPassword)}
                      className="absolute right-3 top-6 transform -translate-y-1/2 text-subhead"
                    >
                      {showPassword ? (
                        // Eye Closed (Password Hidden)
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                          className="w-5 h-5"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M15.75 12a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0z"
                          />
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M2.25 12s3.75-6 9.75-6 9.75 6 9.75 6-3.75 6-9.75 6-9.75-6-9.75-6z"
                          />
                        </svg>
                      ) : (
                        // Eye visible (Password show)
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                          className="w-5 h-5"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M3 12s3.75-6 9.75-6 9.75 6 9.75 6-3.75 6-9.75 6S3 12 3 12z"
                          />
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M15.75 12a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0z"
                          />
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M19.5 4.5l-15 15"
                          />
                        </svg>
                      )}
                    </button>
                  </div>
                  <div className="mb-2 relative">
                    <input
                      type={showConfirmPassword ? "text" : "password"}
                      name="confirmPassword"
                      placeholder="Confirm Password"
                      required
                      value={confirmPassword}
                      onChange={(e) => setConfirmPassword(e.target.value)}
                      className="mt-1 w-full px-3 py-2 border !border-inputfieldborder pr-10 bg-white outline-none text-13 font-Montserratmedium text-forgetpassword min-h-[42px]"
                    />
                    <button
                      type="button"
                      onClick={() =>
                        setShowConfirmPassword(!showConfirmPassword)
                      }
                      className="absolute right-3 top-6 transform -translate-y-1/2 text-subhead"
                    >
                      {showConfirmPassword ? (
                        // Eye Closed (Password Hidden)
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                          className="w-5 h-5"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M15.75 12a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0z"
                          />
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M2.25 12s3.75-6 9.75-6 9.75 6 9.75 6-3.75 6-9.75 6-9.75-6-9.75-6z"
                          />
                        </svg>
                      ) : (
                        // Eye visible (Password show)
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                          className="w-5 h-5"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M3 12s3.75-6 9.75-6 9.75 6 9.75 6-3.75 6-9.75 6S3 12 3 12z"
                          />
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M15.75 12a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0z"
                          />
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M19.5 4.5l-15 15"
                          />
                        </svg>
                      )}
                    </button>
                  </div>
                  <button
                    type="submit"
                    disabled={loading}
                    className="my-3 px-8 py-2 bg-buttonbg text-base text-white focus:outline-none font-BonaNovabold w-full disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    {loading ? "Processing..." : "Finish sign up"}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
        <div className="md:w-6/12 w-full hidden md:block">
          <SignupSlider />
        </div>
      </div>
</>
  );
};

export default Finishsignup;
